/*
 *
 * CompanyData Actions
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 05-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_SAVE_ID_SELECTED: '@@CompanyData/save_id_selected',
  DO_GET_COMPANY_DATA: '@@CompanyData/get_company_data',
  DO_GET_EXCHANGE_RATES: '@@CompanyData/get_exchange_rates',
  DO_ANSWER_QUESTION: '@@CompanyData/answer_question',
  DO_SEND_QUESTIONNAIRE: '@@CompanyData/send_questionnaire',
  DO_GET_SHOPS: '@@CompanyData/get_shops',
  DO_GET_SHOP_DETAIL: '@@CompanyData/get_shop_detail',
  DO_EDIT_SHOP_ALIAS: '@@CompanyData/edit_shop_alias',
  DO_EDIT_IBAN_EXECUTOR_DATA: '@@CompanyData/edit_iban_executor_data',
  DO_GET_CATEGORY_DETAILS: '@@CompanyData/get_category_details',
  DO_EDIT_CATEGORY: '@@CompanyData/edit_category',
  DO_UPDATE_EXECUTOR_IBAN_ADDRESS: '@@CompanyData/update_executor_iban_address',
  DO_UPDATE_EXECUTOR_IBAN_DOCUMENT: '@@CompanyData/update_executor_iban_document',
  DO_UPDATE_IBAN_CONVENTION: '@@CompanyData/update_iban_convention',
  DO_GET_SHOP_DETAILS_RECAP: '@@CompanyData/get_shop_details_recap',
  DO_PUT_SHOP_DETAILS_RECAP: '@@CompanyData/put_shop_details_recap',
  DO_UPDATE_IBAN_ENTE_DATA: '@@CompanyData/update_iban_ente_data',
  DO_UPDATE_IBAN: '@@CompanyData/update_iban',
  DO_GET_COBA_INFO: '@@CompanyData/get_coba_info',
  DO_GET_PCI_DATA: '@@CompanyData/get_pci_data',
  DO_SAVE_TERMINAL_DATAS: '@@CompanyData/save_terminal_datas',
  DO_GET_TERMINALS_DISACTIVE: '@@CompanyData/get_terminals_disactive',
  DO_GET_ACTION_GUARANTEE: '@@CompanyData/get_action_guarantee',
  DO_COMPILE_QUESTIONNAIRE: '@@CompanyData/compile_questionnaire',

  DO_GET_EXPORT_PCI_DOCUMENT: '@@CompanyData/get_export_pci_document',
  DO_SAVE_ALIAS: '@@CompanyData/save_alias',
  DO_EDIT_TERMINAL_ALIAS: '@@CompanyData/edit_terminal_alias',
  DO_SAVE_PAYLOAD_EDIT_ALIAS: '@@CompanyData/save_payload_edit_alias',
  DO_SET_IS_FROM_TERMINAL_DETAIL: '@@CompanyData/set_is_from_terminal_detail',
  DO_CONFIRM_CONVENTIONAL_CHOICE: '@@CompanyData/confirm_conventional_choice',
  DO_SUBMIT_FOREIGN_IBAN_COBA: '@@CompanyData/submit_foreign_iban_coba',
  DO_GET_EMIT_NATION: '@@CompanyData/get_emit_nation',
  DO_DOWNLOAD_SHOP_TERMINALS: '@@CompanyData/download_shop_terminals',
  DO_GET_TERMINAL_QR_CODE: '@@CompanyData/get_terminal_qr_code',
  // @generator action:route:type
  // @generator action:type:request
  ...createRequestTypes('@@CompanyData', 'COMPILE_QUESTIONNAIRE'),
  ...createRequestTypes('@@CompanyData', 'GET_COMPANY_DATA'),
  ...createRequestTypes('@@CompanyData', 'GET_EXCHANGE_RATES'),
  ...createRequestTypes('@@CompanyData', 'GET_SHOPS'),
  ...createRequestTypes('@@CompanyData', 'GET_SHOP_DETAIL'),
  ...createRequestTypes('@@CompanyData', 'EDIT_SHOP_ALIAS'),
  ...createRequestTypes('@@CompanyData', 'ANSWER_QUESTION'),
  ...createRequestTypes('@@CompanyData', 'SEND_QUESTIONNAIRE'),
  ...createRequestTypes('@@CompanyData', 'GET_CATEGORY_DETAILS'),
  ...createRequestTypes('@@CompanyData', 'EDIT_CATEGORY'),
  ...createRequestTypes('@@CompanyData', 'GET_SHOP_DETAILS_RECAP'),
  ...createRequestTypes('@@CompanyData', 'PUT_SHOP_DETAILS_RECAP'),
  ...createRequestTypes('@@CompanyData', 'GET_CREDITOR_DATA'),
  ...createRequestTypes('@@CompanyData', 'UPDATE_IBAN'),
  ...createRequestTypes('@@CompanyData', 'GET_COBA_INFO'),
  ...createRequestTypes('@@CompanyData', 'GET_PCI_DATA'),
  ...createRequestTypes('@@CompanyData', 'GET_TERMINALS_DISACTIVE'),
  ...createRequestTypes('@@CompanyData', 'GET_TERMINAL_QR_CODE'),
  ...createRequestTypes('@@CompanyData', 'GET_ACTION_GUARANTEE'),
  ...createRequestTypes('@@CompanyData', 'GET_EXPORT_PCI_DOCUMENT'),
  ...createRequestTypes('@@CompanyData', 'EDIT_TERMINAL_ALIAS'),
  ...createRequestTypes('@@CompanyData', 'CONFIRM_CONVENTIONAL_CHOICE'),
  ...createRequestTypes('@@CompanyData', 'SUBMIT_FOREIGN_IBAN_COBA'),
  ...createRequestTypes('@@CompanyData', 'GET_EMIT_NATION'),
  ...createRequestTypes('@@CompanyData', 'DOWNLOAD_SHOP_TERMINALS')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name getEmitNation
* @return {object} - The action object
*/
export const getEmitNation = new MakeRequest('CompanyData', 'get_emit_nation')
/** @action request
* * Insert a description
* @name submitForeignIbanCoba
* @return {object} - The action object
*/
export const submitForeignIbanCoba = new MakeRequest('CompanyData', 'submit_foreign_iban_coba')
/** @action request
* * Insert a description
* @name confirmConventionalChoice
* @return {object} - The action object
*/
export const confirmConventionalChoice = new MakeRequest('CompanyData', 'confirm_conventional_choice')
/** @action request
* * Insert a description
* @name editTerminalAlias
* @return {object} - The action object
*/
export const editTerminalAlias = new MakeRequest('CompanyData', 'edit_terminal_alias')
/** @action request
* * Insert a description
* @name getExportPciDocument
* @return {object} - The action object
*/
export const getExportPciDocument = new MakeRequest('CompanyData', 'get_export_pci_document')
/** @action request
* * Insert a description
* @name getActionGuarantee
* @return {object} - The action object
*/
export const getActionGuarantee = new MakeRequest('CompanyData', 'get_action_guarantee')
/** @action request
* * Insert a description
* @name answerQuestion
* @return {object} - The action object
*/
export const answerQuestion = new MakeRequest('CompanyData', 'answer_question')

/** @action request
* * Insert a description
* @name sendQuestionnaire
* @return {object} - The action object
*/
export const sendQuestionnaire = new MakeRequest('CompanyData', 'send_questionnaire')

/** @action request
* * Insert a description
* @name getTerminalsDisactive
* @return {object} - The action object
*/
export const getTerminalsDisactive = new MakeRequest('CompanyData', 'get_terminals_disactive')
/** @action request
* * Insert a description
* @name getTerminalQrCode
* @return {object} - The action object
*/
export const getTerminalQrCode = new MakeRequest('CompanyData', 'get_terminal_qr_code')
/** @action request
* * Insert a description
* @name compileQuestionnaire
* @return {object} - The action object
*/
export const compileQuestionnaire = new MakeRequest('CompanyData', 'compile_questionnaire')
/** @action request
* * Insert a description
* @name getPciData
* @return {object} - The action object
*/
export const getPciData = new MakeRequest('CompanyData', 'get_pci_data')
/** @action request
* * Insert a description
* @name getCobaInfo
* @return {object} - The action object
*/
export const getCobaInfo = new MakeRequest('CompanyData', 'get_coba_info')
/** @action request
 * * Insert a description
 * @name getCreditorData
 * @return {object} - The action object
 */
export const getCreditorData = new MakeRequest('CompanyData', 'get_creditor_data')
/** @action request
 * * Insert a description
 * @name updateIban
 * @return {object} - The action object
 */
export const updateIban = new MakeRequest('CompanyData', 'update_iban')
/** @action request
 * * Insert a description
 * @name getCompanyData
 * @return {object} - The action object
 */
export const getCompanyData = new MakeRequest('CompanyData', 'get_company_data')

/** @action request
 * * Insert a description
 * @name getShops
 * @return {object} - The action object
 */
export const getShops = new MakeRequest('CompanyData', 'get_shops')

/** @action request
 * * Insert a description
 * @name getShopDetail
 * @return {object} - The action object
 */
export const getShopDetail = new MakeRequest('CompanyData', 'get_shop_detail')

/** @action request
 * * Insert a description
 * @name editShopAlias
 * @return {object} - The action object
 */
export const editShopAlias = new MakeRequest('CompanyData', 'edit_shop_alias')

/** @action request
 * * Insert a description
 * @name getTerminals
 * @return {object} - The action object
 */
export const getTerminals = new MakeRequest('CompanyData', 'get_terminals')

/** @action request
* * Insert a description
* @name getCategoryDetails
* @return {object} - The action object
*/
export const getCategoryDetails = new MakeRequest('CompanyData', 'get_category_details')

/** @action request
* * Insert a description
* @name editCategory
* @return {object} - The action object
*/
export const editCategory = new MakeRequest('CompanyData', 'edit_category')
// @generator action:route
/** @action
 * * Insert a description
 * @name getShopDetailsRecap
 * @return {object} - The action object
 */

export const getShopDetailsRecap = new MakeRequest('CompanyData', 'get_shop_details_recap')
/** @action request
* * Insert a description
* @name doSaveTerminalDatas
* @return {object} - The payload object
*/
export const doSaveTerminalDatas = payload => createAction(actionTypes.DO_SAVE_TERMINAL_DATAS, { payload })
/** @action request
* * Insert a description
* @name downloadShopTerminals
* @return {object} - The action object
*/
export const downloadShopTerminals = new MakeRequest('CompanyData', 'download_shop_terminals')

/** @action
* * Insert a description
* @name SaveIdSelected
* @return {object} - The payload object
*/
export const doSaveIdSelected = payload => createAction(actionTypes.DO_SAVE_ID_SELECTED, { payload })
/** @action
 * * Insert a description
 * @name putShopDetailsRecap
 * @return {object} - The action object
 */
export const putShopDetailsRecap = new MakeRequest('CompanyData', 'put_shop_details_recap')
/** @action
* * Insert a description
* @name AnswerQuestion
* @return {object} - The payload object
*/
export const doAnswerQuestion = payload => createAction(actionTypes.DO_ANSWER_QUESTION, { payload })

// @generator action:route
/** @action
* * Insert a description
* @name GetEmitNation
* @return {object} - The payload object
*/
export const doGetEmitNation = payload => createAction(actionTypes.DO_GET_EMIT_NATION, { payload })
/** @action
* * Insert a description
* @name SubmitForeignIbanCoba
* @return {object} - The payload object
*/
export const doSubmitForeignIbanCoba = payload => createAction(actionTypes.DO_SUBMIT_FOREIGN_IBAN_COBA, { payload })
/** @action
* * Insert a description
* @name ConfirmConventionalChoice
* @return {object} - The payload object
*/
export const doConfirmConventionalChoice = payload => createAction(actionTypes.DO_CONFIRM_CONVENTIONAL_CHOICE, { payload })
/** @action
* * Insert a description
* @name SetIsFromTerminalDetail
* @return {object} - The payload object
*/
export const doSetIsFromTerminalDetail = payload => createAction(actionTypes.DO_SET_IS_FROM_TERMINAL_DETAIL, { payload })
/** @action
* * Insert a description
* @name SavePayloadEditAlias
* @return {object} - The payload object
*/
export const doSavePayloadEditAlias = payload => createAction(actionTypes.DO_SAVE_PAYLOAD_EDIT_ALIAS, { payload })
/** @action
* * Insert a description
* @name EditTerminalAlias
* @return {object} - The payload object
*/
export const doEditTerminalAlias = payload => createAction(actionTypes.DO_EDIT_TERMINAL_ALIAS, { payload })
/** @action
* * Insert a description
* @name SaveAlias
* @return {object} - The payload object
*/
export const doSaveAlias = payload => createAction(actionTypes.DO_SAVE_ALIAS, { payload })
/** @action
* * Insert a description
* @name GetExportPciDocument
* @return {object} - The payload object
*/
export const doGetExportPciDocument = payload => createAction(actionTypes.DO_GET_EXPORT_PCI_DOCUMENT, { payload })
/** @action
* * Insert a description
* @name GetActionGuarantee
* @return {object} - The payload object
*/
export const doGetActionGuarantee = payload => createAction(actionTypes.DO_GET_ACTION_GUARANTEE, { payload })
/** @action
* * Insert a description
* @name DoGetTerminalsDisactive
* @return {object} - The payload object
*/
export const doGetTerminalsDisactive = shopId => createAction(actionTypes.DO_GET_TERMINALS_DISACTIVE, { shopId })
/** @action
* * Insert a description
* @name DoGetTerminalQrCode
* @return {object} - The payload object
*/
export const doGetTerminalQrCode = payload => createAction(actionTypes.DO_GET_TERMINAL_QR_CODE, { payload })
/** @action
* * Insert a description
* @name DoDownloadShopTerminals
* @return {object} - The payload object
*/
export const doDownloadShopTerminals = payload => createAction(actionTypes.DO_DOWNLOAD_SHOP_TERMINALS, { payload })
/** @action
* * Insert a description
* @name GetPciData
* @return {object} - The payload object
*/
export const doGetPciData = vatNumber => createAction(actionTypes.DO_GET_PCI_DATA, { vatNumber })
/** @action
* * Insert a description
* @name GetCobaInfo
* @return {object} - The payload object
*/
export const doGetCobaInfo = shopCode => createAction(actionTypes.DO_GET_COBA_INFO, { shopCode })
/** @action
 * * Insert a description
 * @name UpdateIban
 * @return {object} - The payload object
 */
export const doUpdateIban = (payload) => createAction(actionTypes.DO_UPDATE_IBAN, { payload, isSca: true })
/** @action
 * * Insert a description
 * @name UpdateIbanEnteData
 * @return {object} - The payload object
 */
export const doUpdateIbanEnteData = (payload) => createAction(actionTypes.DO_UPDATE_IBAN_ENTE_DATA, { payload })
/** @action
 * * Insert a description
 * @name UpdateIbanConvention
 * @return {object} - The payload object
 */
export const doUpdateIbanConvention = (payload) => createAction(actionTypes.DO_UPDATE_IBAN_CONVENTION, { payload })
/** @action
 * * Insert a description
 * @name UpdateExecutorIbanAddress
 * @return {object} - The payload object
 */
export const doUpdateExecutorIbanAddress = (payload) =>
  createAction(actionTypes.DO_UPDATE_EXECUTOR_IBAN_ADDRESS, { payload })
/** @action
* * Insert a description
* @name CompileQuestionnaire
* @return {object} - The payload object
*/
export const doCompileQuestionnaire = payload => createAction(actionTypes.DO_COMPILE_QUESTIONNAIRE, { payload })

/** @action
* * Insert a description
 * @name UpdateIbanCreditorData
 * @return {object} - The payload object
 */
export const doUpdateIbanExecutorData = (payload) => createAction(actionTypes.DO_EDIT_IBAN_EXECUTOR_DATA, { payload })
/** @action
 * * Insert a description
 * @name UpdateExecutorIbanDocument
 * @return {object} - The payload object
 */
export const doUpdateExecutorIbanDocument = (payload) =>
  createAction(actionTypes.DO_UPDATE_EXECUTOR_IBAN_DOCUMENT, { payload })
/** @action
 * * Insert a description
 * @name GetCompanyData
 * @return {object} - The payload object
 */
export const doGetCompanyData = (payload) => createAction(actionTypes.DO_GET_COMPANY_DATA, { payload })

/** @action request
 * * Retrieves the exchange-rate catalogue.
 * @name GetExchangeRates
 * @return {object} - The payload object
 */
export const getExchangeRates = new MakeRequest('CompanyData', 'get_exchange_rates')

/** @action
 * * Insert a description
 * @name GetShops
 * @return {object} - The payload object
 */
export const doGetShops = (payload) => createAction(actionTypes.DO_GET_SHOPS, { payload })

/** @action
 * * Retrieves the exchange-rate catalogue.
 * @name GetExchangeRates
 * @return {object} - The payload object
 */
export const doGetExchangeRates = (payload) => createAction(actionTypes.DO_GET_EXCHANGE_RATES, { payload })

/** @action
 * * Insert a description
 * @name GetShopDetail
 * @return {object} - The payload object
 */
export const doGetShopDetail = (payload) => createAction(actionTypes.DO_GET_SHOP_DETAIL, { payload })

/** @action
 * * Insert a description
 * @name EditShopAlias
 * @return {object} - The payload object
 */
export const doEditShopAlias = (payload) => createAction(actionTypes.DO_EDIT_SHOP_ALIAS, { payload })

/** @action
 * * Insert a description
 * @name GetShopDetailsRecap
 * @return {object} - The payload object
 */
export const doGetShopDetailsRecap = (payload) => createAction(actionTypes.DO_GET_SHOP_DETAILS_RECAP, { payload })

/** @action
 * * Insert a description
 * @name PutShopDetailsRecap
 * @return {object} - The payload object
 */
export const doPutShopDetailsRecap = (payload) =>
  createAction(actionTypes.DO_PUT_SHOP_DETAILS_RECAP, { payload, isSca: true })

/** @action
 * * Insert a description
 * @name GetCategoryDetails
 * @return {object} - The payload object
 */
export const doGetCategoryDetails = (payload) => createAction(actionTypes.DO_GET_CATEGORY_DETAILS, { payload })

/** @action
* * Insert a description
* @name EditCategory
* @return {object} - The payload object
*/
export const doEditCategory = (category, shopCode, file) => createAction(actionTypes.DO_EDIT_CATEGORY, { payload: { category, shopCode, file }, isSca: true })
/** @action
* * Insert a description
* @name doSendQuestionnaire
* @return {object} - The payload object
*/
export const doSendQuestionnaire = payload => createAction(actionTypes.DO_SEND_QUESTIONNAIRE, { payload })
